import { FetchResult, Observable } from "@apollo/client";
import { NetworkError } from "@apollo/client/errors";

import { getErrorMessageFromCode } from "../../../service/ValidationErrorFormatter";
import { Toast } from "../../../widget";
import { ERROR_APPLICATION } from "../../errorConstants";
import { logErrorWithDetail } from "./errorHandlerUtils";

// for any other type of error, display an error message
// and log an error (as this should never occur in the normal
// course of events)
export const otherErrorHandler = (networkError: NetworkError): Observable<FetchResult> | undefined => {
  logErrorWithDetail("GraphQL error sending request", networkError);
  Toast.error({
    message: getErrorMessageFromCode(ERROR_APPLICATION),
  });
  return undefined;
};
